import { useState } from "react";
import { useEditorConfig } from "../config/use-config";
import { useGroupQueryParam } from "../group-filter-in-url/use-group-query-param";
import { ALL } from "./constants";

export function useSelectedGroupState() {
  const { useSelectedGroupAsQueryParam } = useEditorConfig();
  const { group, setGroup } = useGroupQueryParam();

  const initialValue = useSelectedGroupAsQueryParam ? (group ?? ALL) : ALL;

  const [selectedGroup, _setSelectedGroup] = useState<string>(initialValue);

  const setSelectedGroup = (group: string) => {
    _setSelectedGroup(group);

    if (useSelectedGroupAsQueryParam) {
      setGroup(group);
    }
  };

  return {
    selectedGroup,
    setSelectedGroup,
  };
}
